module.exports = __webpack_public_path__ + "img/icon.9cfea46f.png";